<template>
  <div>
    <div
      class="nav-bar-content"
      :class="{ 'nav-bar-opacity1': opacity == 1 }"
      :style="{
        height: height + 'px',
        paddingTop: statusBarHeight + 'px',
        backgroundColor: 'rgba(255,255,255,' + opacity + ')'
      }"
    >
      <div
        class="back"
        @click="bindBack"
        :style="{ backgroundColor: getButtonColor(opacity) }"
        ><span class="iconfont icon-you"></span
      ></div>
      <div class="title">{{ opacity >= 1 ? '健萌最用心教练评选' : '' }}</div>
      <div
        class="share"
        v-if="activityInfo"
        @click="bindShare"
        :style="{ backgroundColor: getButtonColor(opacity) }"
        ><span class="iconfont icon-fenxiang11"></span
      ></div>
    </div>
  </div>
</template>

<script>
import AppNavBar from '@/components/app/nav-bar/index.vue'
export default {
  props: {
    opacity: {
      type: Number,
      default: 0
    }
  },
  components: { AppNavBar },
  data() {
    return {
      statusBarHeight: 0,
      height: 0
    }
  },
  computed: {
    activityInfo() {
      return this.$store.state.coachActivity2024.activityInfo
    }
  },
  watch: {
    opacity() {}
  },
  created() {
    this.getBottomContentHeight()
  },
  methods: {
    getButtonColor(opacity) {
      return 'rgba(0,0,0,' + (opacity <= 0.5 ? 0.5 : 0.5 - 0.5 * opacity) + ')'
    },
    bindBack() {
      this.$http.appBack()
    },
    bindShare() {
      this.$emit('share')
    },
    async getBottomContentHeight() {
      if (this.$betterwe.isApp()) {
        let res = await this.$betterwe.getAppBarHeight().catch(() => {})
        if (res) {
          this.statusBarHeight = res.statusBarHeight
          this.height = this.statusBarHeight + res.toolsBarHeight
        }
      } else {
        this.statusBarHeight = 20
        this.height = this.statusBarHeight + 40
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.nav-bar-content {
  position: fixed;
  width: 100%;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 0px 15px 10px 19px;
  z-index: 2;
  .title {
    text-align: center;
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-weight: bold;
    font-size: 18px;
    color: #000000;
    line-height: 25px;
  }
  .back,
  .share {
    font-weight: bold;
    color: #fff;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    box-sizing: border-box;
    background: rgba(0, 0, 0, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .back {
    padding-right: 2px;
  }
  .icon-you {
    font-size: 20px;

    transform: rotate(180deg);
  }
  .icon-fenxiang11 {
    font-weight: normal;
    font-size: 20px;
  }
}
.nav-bar-opacity1 {
  .share,
  .back {
    color: #050b27;
  }
}
</style>
